import { VStack } from "@chakra-ui/react"
import React from "react"
import { UpdateIBeaconForm } from "../../forms"

export type UpdateIBeaconProps = {
	ibeaconId: string
}

export const UpdateIBeacon: React.FC<UpdateIBeaconProps> = ({ ibeaconId }) => {
	return (
		<VStack w="full" maxW="sm" spacing={6}>
			<UpdateIBeaconForm ibeaconId={ibeaconId} />
		</VStack>
	)
}
